module.exports = __webpack_public_path__ + "assets/img/pencil-gray.6cec9266.svg";